module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-ons-page', {
    attrs: {
      "modifier": "white"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "picture",
    style: ({
      backgroundImage: 'url(' + _vm.user_image + ')'
    })
  }), _vm._v(" "), (_vm.user) ? _c('div', {
    staticClass: "info"
  }, [_c('p', {
    staticClass: "fullName"
  }, [_vm._v(_vm._s(_vm.user.pro_fName) + " " + _vm._s(_vm.user.pro_lName))]), _vm._v(" "), _c('p', {
    staticClass: "address"
  }, [_vm._v(_vm._s(_vm.user.pro_city) + ", " + _vm._s(_vm.user_country))]), _vm._v(" "), _c('div', {
    staticClass: "logout",
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "fas fa-sign-out-alt"
  }), _vm._v(" " + _vm._s(_vm.$t("Déconnexion")) + "\n        ")])]) : _vm._e()])]), _vm._v(" "), _c('v-ons-list', [(_vm.user.project) ? _c('v-ons-list-item', {
    attrs: {
      "tappable": ""
    },
    on: {
      "click": function($event) {
        return _vm.push('Project')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-home"
  }), _vm._v(_vm._s(_vm.$t("Mon projet")))]) : _vm._e(), _vm._v(" "), _c('v-ons-list-item', {
    attrs: {
      "tappable": ""
    },
    on: {
      "click": function($event) {
        return _vm.push('Profile')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-user"
  }), _vm._v(_vm._s(_vm.$t("Mon profil")))]), _vm._v(" "), _c('v-ons-list-item', {
    attrs: {
      "tappable": ""
    },
    on: {
      "click": function($event) {
        return _vm.push('Sponsorship')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-gift"
  }), _vm._v(_vm._s(_vm.$t("Parrainage")))])], 1), _vm._v(" "), _c('language-switcher')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-298a9323","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Menu.vue
// module id = 242
// module chunks = 0